import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';

@Directive({
  selector: '[appOverlayBackdrop]',
})
export class OverlayBackdropDirective implements AfterViewInit, OnDestroy  {

  @Input('appOverlayBackdrop') overlayPanel!: OverlayPanel;

  private backdrop!: HTMLElement | null;
  private originalShow!: (event?: any) => void;
  private originalHide!: () => void;

  private firstShowIgnored = false;

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    if (!this.overlayPanel) return;

    // Store original methods (NOW overlayPanel exists)
    this.originalShow = this.overlayPanel.show.bind(this.overlayPanel);
    this.originalHide = this.overlayPanel.hide.bind(this.overlayPanel);

    // Override show
    this.overlayPanel.show = (...args: any[]) => {

      // Call the real show()
      this.originalShow(...args);

      // Ignore first auto-show triggered by PrimeNG inside dialogs
      if (!this.firstShowIgnored) {
        this.firstShowIgnored = true;
        return;
      }

      // User-triggered show -> show backdrop
      setTimeout(() => this.showBackdrop(), 0);
    };

    // Override hide
    this.overlayPanel.hide = () => {
      this.originalHide();
      setTimeout(() => this.hideBackdrop(), 0);
    };
  }

  private showBackdrop() {
    if (this.backdrop) return;

    this.backdrop = document.createElement('div');
    this.backdrop.classList.add('custom-backdrop');

    Object.assign(this.backdrop.style, {
      position: 'fixed',
      inset: '0',
      background: 'rgba(0,0,0,0.45)',
      backdropFilter: 'blur(2px)',
      zIndex: '900'
    });

    document.body.appendChild(this.backdrop);
  }

  private hideBackdrop() {
    if (this.backdrop && document.body.contains(this.backdrop)) {
      document.body.removeChild(this.backdrop);
    }
    this.backdrop = null;
  }

  ngOnDestroy() {
    if (this.originalShow) this.overlayPanel.show = this.originalShow;
    if (this.originalHide) this.overlayPanel.hide = this.originalHide;
    this.hideBackdrop();
  }
}
